<!--单行回答(按钮/链接/文本)-->
<template>
  <div class="message-template clearfix">
    <div class="person-icon"></div>
    <div class="message-container">
      <div class="triangle"></div>
      <div class="message">
        <div v-if="type == 1">
          <span class="message-info">若未解决您的问题, 请选择</span>
          <span class="btn" @click="needService" :class="disabledClass" data-spm="2265317">人工服务</span>
        </div>
        <div v-if="type == 2">
          <span class="message-info">亲，您还有其他问题吗？如果没有，</span>
          <a class="" @click="needLeave" :class="disabledClass">点击退出人工客服</a>
        </div>
        <div v-if="type == 3">
          <span class="message-info">亲, 当前包裹在运送途中, 您可以选择</span>
          <span class="btn" @click="urgent" :class="disabledClass" data-spm="2263465">派送加急</span>
        </div>
      </div>
    </div>
  </div>
</template>
<style>

</style>
<script>
  export default {
    props: ['type'],
    data() {
      return {
        disabledClass: ''
      }
    },
    components: {
    },
    methods: {
      needService() {
        this.disabledClass = "disabled";
        this.$dispatch('need-service');
      },
      needLeave() {
        this.disabledClass = "disabled";
        this.$dispatch('need-leave');
      },
      urgent() {
        this.disabledClass = "disabled";
        this.$dispatch('urgent-order');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Answers.vue?c091420c